import { render, staticRenderFns } from "./state-idle.vue?vue&type=template&id=47baa1c3&scoped=true&"
import script from "./state-idle.vue?vue&type=script&lang=js&"
export * from "./state-idle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47baa1c3",
  null
  
)

export default component.exports